export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00647.30004eec.png";